import styles from 'views/PageviewEvent/PageviewEventForm.css';
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import _ from '../../utils/lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { domain, path, empty } from 'constants/operators';
// import PageviewEventList from 'views/PageviewEvent/PageviewEventList';
import EventInsight from 'views/widgets/EventInsight';
import PageviewEventDropdown from 'views/PageviewEvent/PageviewEventDropdown';
import Confirm from 'views/widgets/Confirm';
import InputText from 'views/widgets/Input/InputText';
import Button from 'views/widgets/Button';
import * as actionsPageview from 'redux/modules/pageview/pageviewActions';
import ChartContainer from 'views/widgets/ChartContainer';
import { editorStateActions } from 'redux/modules/editorState';
import eventGroupSvc from 'services/eventGroupService';
import contextService from 'services/contextService';
import { prettifyNumber } from 'utils/number';
import { beautifyPageviewOperators } from 'utils/operatorPurge';
import Loader from 'views/BaseElements/Loader/Loader';
import configSvc from 'services/configService';

const EVENT_NAME_MAX_LENGTH = 64;

class PageviewEventForm extends Component {
  static propTypes = {
    actions: PropTypes.object,
    current: PropTypes.object,
    events: PropTypes.array,
    onHide: PropTypes.func,
    pageview: PropTypes.object,
    projectId: PropTypes.string,
    pageviewId: PropTypes.string,
    removePageviewId: PropTypes.func,
    editorActions: PropTypes.object
  }

  constructor (props) {
    super(props);
    this.saveCurrentEvent = _.debounce(this.saveCurrentEvent, 1500);
    this.verifyName = _.debounce(this.verifyName, 800);
  }

  state = {
    input: {
      domain: document.location.hostname,
      path: document.location.pathname
    },
    loading: false,
    operator: {},
    current: '',
    showOptions: false,
    changed: false,
    statNeedUpdate: false,
    nameTaken: false,
    deleting: false,
    deleteId: '',
    stats: defaultStats
  }

  componentDidMount () {
    const { actions, current, projectId } = this.props;
    actions.getPageviewEvents(projectId);
    if (current) {
      this.setState({
        input: current.inputs || {
          domain: document.location.hostname,
          path: document.location.pathname
        },
        operator: current.operators || {}
      });
    } else {
      this.saveCurrentEvent();
    }
    // this.getStats();
  }

  componentWillReceiveProps (nextProps) {
    const { pageviewId, removePageviewId } = this.props;
    console.log(222, this.props);
    if (!_.isEmpty(pageviewId)) {
      this.onClickEvent(pageviewId)();
      removePageviewId();
    }
  }

  handleRefreshCall = () => {
    this.getStats();
  }

  render () {
    const { input, current, operator, showOptions, statNeedUpdate,
      nameTaken, deleting, loading, stats } = this.state;
    const { events } = this.props;
    let disabled = true;
    if (input && input.eventName && input.domain && input.eventName.trim() && input.domain.trim()) {
      disabled = false;
    }
    const editable = configSvc.isEditEnabled() || !current;
    const dataEvent = this.state.stats.events;
    const { total } = this.state.stats;
    const isDefaultState = this.checkIsDefaultState();
    let updateStyle = window.innerWidth <= 480 ? {fontSize: '12px !important', padding: '4px !important'} : {};

    return (
      <div className={classnames(styles.modal_wrapper, {[styles.modal_wrapper_complete]: events.length,
        [styles.modal_maxHeight]: showOptions})}>
        <div className={styles.modal}>
          {
            isDefaultState && !loading &&
              <div className={styles.preview}>
                <button
                  className={styles.previewButton}
                  onClick={this.handleRefreshCall}>
                  Preview Event Metric
                </button>
              </div>
          }
          {
            loading &&
              <div className={styles.chart_container}>
                <Loader/>
              </div>
          }
          {
            !loading && stats.hasOwnProperty('totalrevenue') &&
            stats.totalrevenue >= 0 && stats.overallconversionrate >= 0 &&
            stats.eventconversionrate >= 0 && !isDefaultState &&
              <div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8}}>
                  <span style={{fontSize: '14px !important', fontWeight: '600 !important', marginRight: '12px'}}>
                    Conversion Contribution
                  </span>
                  {statNeedUpdate &&
                    <button
                      style={updateStyle}
                      className={styles.refreshButton}
                      onClick={this.handleRefreshCall}>
                        {window.innerWidth <= 480 ? 'Update' : 'Definition has changed. Click here to refresh metrics.'}
                    </button>
                  }
                </div>
                <EventInsight
                  type={'Viewed'}
                  {...stats}
                />
              </div>
          }
          {
            !loading && !isDefaultState &&
              <div className={styles.chart_container}>
                <div className={styles.header} style={{ marginTop: 24 }}>
                  <div>
                    <span
                      style={{fontSize: '14px !important', fontWeight: '600 !important', marginRight: '12px'}}>
                      Number of Pageviewers
                    </span>
                    {statNeedUpdate &&
                      (stats.hasOwnProperty('totalrevenue') === false ||
                      (stats.hasOwnProperty('totalrevenue') && stats.totalrevenue === -1)) &&
                      <button
                        className={styles.refreshButton}
                        onClick={this.handleRefreshCall}>Click to Update
                      </button>}
                  </div>
                  <span>Last 7 Days</span>
                </div>
                <ChartContainer
                  width={372}
                  height={50}
                  data={dataEvent}
                  dataKey='clicks'
                  customStyle={{margin: 'auto'}}
                />
                <div className={styles.divmessage} style={{marginTop: 8}}>
                  <span className={styles.count}>{`${prettifyNumber(total.clicks)} `}</span>
                  Pageviews by <span className={styles.count}>{`${prettifyNumber(total.users)} `}</span>Users
                  <div className={styles.divmessagegray}>(Last 7 days)</div>
                </div>
              </div>
          }
          <div className={styles._container}>
            <div style={{marginBottom: 8}}>
              <span className={styles.label} style={{fontSize: '14px !important'}}>Event name</span>
            </div>
            <InputText
              error={nameTaken}
              onChange={this.onChangeInputName}
              maxLength={EVENT_NAME_MAX_LENGTH}
              placeholder={'e.g. Log in'}
              reftype="text"
              value={input['eventName']}
              />
            {
              !!nameTaken &&
                <span className={styles.errorText}>Name taken</span>
            }
          </div>
          <div className={styles._container}>
            <PageviewEventDropdown
              borderStyle={'left-clear'}
              dropdown={operator['domain'] || domain[0]}
              input={input['domain']}
              onClearInput={this.clearInput('domain')}
              label={'Domain'}
              onDropdownChange={this.handleSelectDropdown('domain')}
              onTextChange={this.onChangeInput('domain')}
              options={domain}
              mobileVersion={window.innerWidth <= 480}
              placeholder={'mywebsite.com'}
              disabled={!editable}
              />
            <PageviewEventDropdown
              borderStyle={'left-clear'}
              dropdown={operator['path'] || (input['path'] ? path[0] : empty)}
              input={input['path']}
              label={'path'}
              onClearInput={this.clearInput('path')}
              onDropdownChange={this.handleSelectDropdown('path')}
              onTextChange={this.onChangeInput('path')}
              options={path}
              mobileVersion={window.innerWidth <= 480}
              placeholder={'/'}
              disabled={!editable}
              />
          </div>
          <span onClick={this.showAdvancedOptions} className={styles.textButton}>
            Advanced Options ▾
          </span>
          {
            showOptions &&
              <div className={styles._container}>
                <PageviewEventDropdown
                  borderStyle={'left-clear'}
                  dropdown={operator['query'] || empty}
                  input={input['query']}
                  label={'Query'}
                  onClearInput={this.clearInput('query')}
                  onDropdownChange={this.handleSelectDropdown('query')}
                  onTextChange={this.onChangeInput('query')}
                  options={path}
                  mobileVersion={window.innerWidth <= 480}
                  placeholder={'?'}
                  disabled={!editable}
                  />
                <PageviewEventDropdown
                  borderStyle={'left-clear'}
                  dropdown={operator['hash'] || empty}
                  input={input['hash']}
                  label={'Hash'}
                  onClearInput={this.clearInput('hash')}
                  onDropdownChange={this.handleSelectDropdown('hash')}
                  onTextChange={this.onChangeInput('hash')}
                  options={path}
                  mobileVersion={window.innerWidth <= 480}
                  placeholder={'#'}
                  disabled={!editable}
                  />
                <PageviewEventDropdown
                  borderStyle={'left-clear'}
                  dropdown={operator['name'] || empty}
                  input={input['name']}
                  label={'Title'}
                  onClearInput={this.clearInput('name')}
                  onDropdownChange={this.handleSelectDropdown('name')}
                  onTextChange={this.onChangeInput('name')}
                  options={path}
                  mobileVersion={window.innerWidth <= 480}
                  placeholder={'title'}
                  disabled={!editable}
                  />
              </div>
          }
          <div className={styles.buttons}>
            <Button
              onClick={this.onClick}
              disabled={(current && input['eventName'].length) ? false : disabled}
              className={styles.button_blue}>
              {current ? 'Update Event' : 'Define Event'}
            </Button>
          </div>
        </div>
        {/* {
          events.length > 0 &&
            <PageviewEventList
              events={events}
              selected={current || ''}
              onClickEvent={this.onClickEvent}
              onClickDelete={this.handleDeleteEvent}/>
        } */}

        {
          deleting &&
            <Confirm
              cancelLabel='Cancel'
              confirmLabel='Delete Event'
              onClick={this.confirmDelete}
              title='Delete Event?'>
              <p>
                You are about to delete this event. <br/>
                Are you sure you want to delete?
              </p>
            </Confirm>
        }
      </div>
    );
  }

  handleSelectDropdown = (type) => (selected) => {
    this.setState({
      operator: {
        ...this.state.operator,
        [type]: selected
      },
      changed: true,
      statNeedUpdate: true
    });
    this.saveCurrentEvent();
  };

  handleDeleteEvent = (id) => () => {
    this.setState({
      deleteId: id,
      deleting: true
    });
  }

  confirmDelete = (val) => {
    if (val) {
      const { events, editorActions } = this.props;
      const event = { attrs: events.find(item => item.id === this.state.deleteId) };
      editorActions.deleteEvent(event);
    }
    this.setState({
      deleting: false
    });
  }

  clearInput = (key) => (e) => {
    this.setState({
      input: {
        ...this.state.input,
        [key]: ''
      }
    });
  }

  onChangeInputName = (e) => {
    this.setState({
      input: {
        ...this.state.input,
        eventName: e.target.value
      },
      changed: true,
      nameTaken: false,
      statNeedUpdate: true
    });
    this.saveCurrentEvent();
    this.verifyName();
  }

  onChangeInput = (type) => (e) => {
    this.setState({
      input: {
        ...this.state.input,
        [type]: e.target.value
      },
      changed: true,
      statNeedUpdate: true,
      nameTaken: false
    });
    this.saveCurrentEvent();
  }

  onClick = () => {
    const { projectId, events, actions, onHide } = this.props;
    const { input, operator, current, changed } = this.state;
    if (!input.eventName.trim().length) return;
    if (current && changed) {
      const event = events.find(item => item.id === current);
      const content = beautifyPageviewOperators(input, operator);
      actions.updatePageEvent({
        id: event.id,
        name: input.eventName,
        projectId: projectId,
        content
      });
      onHide();
    } else if (!current) {
      const content = beautifyPageviewOperators(input, operator);
      actions.createPageEvent({
        name: input.eventName,
        content: content,
        projectId: projectId
      });
      onHide();
    }
  }

  onClickEvent = (id) => (e) => {
    const { events, current } = this.props;
    console.log(333, events, current);
    if (id === this.state.current) return;
    let changes = {
      input: {
        domain: location.hostname,
        path: location.pathname
      },
      operator: {},
      current: '',
      showOptions: false,
      changed: false,
      nameTaken: false
    };
    if (!id) {
      if (current) {
        changes.input = current.inputs || changes.input;
        changes.operator = current.operators || {};
      }
    } else {
      let inputs = {};
      let operators = {};
      const event = events.find(item => item.id === id);
      console.log(111, events, event);
      inputs.eventName = event.name;
      let hasAdvanced = false;
      event.content.forEach(item => {
        inputs[item.name] = item.value;
        operators[item.name] = item.operator;
        if (item.value && (item.name === 'query' || item.name === 'hash')) {
          hasAdvanced = true;
        }
      });

      changes = {
        ...changes,
        input: inputs,
        operator: operators,
        current: id,
        showOptions: hasAdvanced,
        changed: false
      };
    }
    this.getStats(id);
    this.setState(changes);
  }

  showAdvancedOptions = () => {
    this.setState({
      showOptions: !this.state.showOptions
    });
  }

  saveCurrentEvent = async () => {
    const { input, operator, current } = this.state;
    if (!current) {
      this.props.actions.updateNewPageviewEvent(input, operator);
      // this.getStats();
    }
  }

  verifyName = async () => {
    const { input, current } = this.state;
    const { events } = this.props;
    let event = null;
    if (current) {
      event = events.find(item => item.id === current);
    }

    if (event && (event.name === input.eventName || input.eventName.trim() === event.name.trim())) {
      this.setState({
        nameTaken: false
      });
    } else {
      if (input.eventName.trim()) {
        const isTaken = await hasEventNameTaken(input.eventName);
        this.setState({
          nameTaken: isTaken
        });
      }
    }
  }

  checkIsDefaultState = () => {
    if (_.isEqual(this.state.stats, defaultStats)) {
      return true;
    }
    return false;
  }

  async getStats (id) {
    let endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    let startDate = new Date();
    startDate.setDate(endDate.getDate()-6);
    startDate.setHours(0, 0, 0, 0);

    if (!id) {
      if (!this.state.input) {
        this.setState({
          stats: defaultStats
        });
      } else {
        this.setState({ loading: true, statNeedUpdate: false });

        let operator = this.state.operator || {};
        if (!operator['domain']) operator['domain'] = domain[0];
        if (!operator['path']) operator['path'] = path[0];

        const content = JSON.stringify(beautifyPageviewOperators(this.state.input, this.state.operator));

        let params = {
          library: 'Web',
          scope: 'LOCAL',
          content: content,
          projectId: this.props.projectId,
          eventType: 'PAGEVIEW',
          beginTime: startDate.getTime(),
          endTime: endDate.getTime(),
          timeZone: contextService.get('timeZone')
        };
        let stats = await eventGroupSvc.getStats(params);
        if (!stats.events || stats.events.length === 0) {
          stats.events = defaultStats.events;
        }
        this.setState({ stats }, () => this.setState({ loading: false, changed: this.state.changed }));
      }
    } else {
      this.setState({ loading: true, changed: false });
      const event = this.props.events.find(item => item.id === id);

      let params = {
        projectId: event.projectId,
        content: JSON.stringify(event.content),
        currentContextPath: event.currentContextPath,
        scope: event.scope,
        beginTime: startDate.getTime(),
        endTime: endDate.getTime(),
        timeZone: contextService.get('timeZone'),
        definitionType: event.definitionType,
        library: 'Web',
        eventType: event.eventType
      };
      let stats = await eventGroupSvc.getStats(params);
      if (!stats.events || stats.events.length === 0) {
        stats.events = defaultStats.events;
      }
      this.setState({ stats }, () => this.setState({ loading: false, changed: this.state.changed }));
    }
  }
};

const defaultStats = {
  events: [
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 }
  ],
  total: {
    clicks: 0,
    users: 0
  }
};

const mapStateToProps = (state) => ({
  events: getEvents(state.pageview.byIds, state.pageview.ids) || [],
  current: state.pageview.current,
  loading: state.loading
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionsPageview, dispatch),
  editorActions: bindActionCreators(editorStateActions, dispatch)
});

const getEvents = (state, events) => {
  return events.map(item => state[item]);
};

async function hasEventNameTaken (name) {
  let response = await eventGroupSvc.getEventGroupByName({ name });
  if (response.ok) {
    return true;
  }
  return false;
}

export default connect(mapStateToProps, mapDispatchToProps)(PageviewEventForm);



/** WEBPACK FOOTER **
 ** ./src/views/PageviewEvent/PageviewEventForm.js
 **/